import React, { memo, useCallback } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { ReactComponent as TableViewIcon } from '../../../../assets/icons/app/table-view.icon.svg'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { AuthorMirrorAuthorInterface } from '../../../../core/interface/report/author-mirror-author.interface'
import D3ConstellationAuthorMirror from '../../../analytics-details-v2/view/author-mirror/constellation/D3ConstellationAuthorMirror'
import ShareAnalyticDetailsAuthorsInputs from '../../components/ShareAnalyticDetailsAuthorsInputs'
import {
  analyticDetailsV2StateGetAuthorDetailsData,
  analyticDetailsV2StateGetBookDetailsData,
} from '../../../../store/actions/analytics-details/analytic-details-v2.actions'
import {
  selectAnalyticDetailsStateAnalyticDetailsAuthorsInput,
  selectAnalyticDetailsStateAnalyticDetailsAuthorsOutput,
  selectAnalyticDetailsStateAuthorDetailsSelected,
  selectAnalyticDetailsStateBookDetailsSelected,
} from '../../../../store/getters/analytics-details/analytic-details-v2.getters'

const CardLayoutStyle = styled.div`
  z-index: 0;
  background: rgba(255, 255, 255, 0.01);
`

const ShareAnalyticDetailsAuthorMirrorConstellationCard = ({
  openListCard,
  handleOpenListView,
  handleAuthorHovered,
}: {
  openListCard: boolean
  handleOpenListView: () => void
  handleAuthorHovered: (authorId: string | null) => void
}) => {
  const { t } = useTranslation()
  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    handleOpenListView()
  }

  const authorsInput = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetailsAuthorsInput,
  )

  const authorsMirrorsOutput = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetailsAuthorsOutput,
  )

  const authorDetailsSelected = useAppSelector(
    selectAnalyticDetailsStateAuthorDetailsSelected,
  )

  const bookDetailsSelected = useAppSelector(
    selectAnalyticDetailsStateBookDetailsSelected,
  )

  const dispatch = useAppDispatch()

  const handleCloseBookDetails = useCallback(() => {
    void dispatch(
      analyticDetailsV2StateGetBookDetailsData({ bookDetails: null }),
    )
  }, [bookDetailsSelected])

  const handleAuthorSelected = useCallback(
    (authorDetails: AuthorMirrorAuthorInterface | null) => {
      if (!authorDetails) {
        return
      }

      void dispatch(
        analyticDetailsV2StateGetAuthorDetailsData({ authorDetails }),
      )

      handleCloseBookDetails()
    },
    [authorDetailsSelected],
  )

  return (
    <CardLayoutStyle className="relative flex-auto flex flex-col rounded-xl shadow-lg bg-white basis-2/3">
      <div className="flex items-start justify-between m-2">
        <ShareAnalyticDetailsAuthorsInputs
          authorsInput={authorsInput}
          authorDetailsSelected={authorDetailsSelected}
          handleAuthorSelected={handleAuthorSelected}
        />
        {(!openListCard && (
          <button
            type="button"
            className="flex flex-row gap-2 rounded p-2 items-center justify-center hover:shadow-xl bg-black text-white"
            onClick={handleOnClick}
            style={{
              zIndex: 10,
            }}
          >
            <TableViewIcon />
            <span>{t('commons.buttons.list')}</span>
          </button>
        )) ||
          null}
      </div>

      <D3ConstellationAuthorMirror
        authorsInput={authorsInput}
        authorsOutput={authorsMirrorsOutput}
        handleAuthorHovered={handleAuthorHovered}
        authorDetailsSelected={authorDetailsSelected}
        handleAuthorSelected={handleAuthorSelected}
      />
    </CardLayoutStyle>
  )
}

export default memo(ShareAnalyticDetailsAuthorMirrorConstellationCard)
